'use strict';
var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');
var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');
var scrollUtils = require('../utils/scrollUtils');
var processInclude = require('base/util');
const { tabIdentity } = require('app_honda_cars/utils/tabIdentity');

processInclude(require('../stores/stores'));
const isVersion2 = document.documentElement.classList.contains('version-2');
const BREAKPOINTS = isVersion2 ? {
    sm: 1023,
    md: 1280,
    lg: 1440
} : {
    sm: 441,
    md: 1024,
    lg: 1440
};

window.sidebar = {
    elements: {
        $sidebar: $('#page-sidebar')
    },
    downloadBrochure: {
        initGetDealers: function () {
            var $sidebarLocationDealers = $('#sidebar-location-dealers');
            var $sidebarLocationList = $('.sidebar-location-list');

            if (!$sidebarLocationDealers.length || !$sidebarLocationList.length) {
                return;
            }

            $.ajax({
                url: $sidebarLocationDealers.data('action'),
                type: 'get',
                dataType: 'json',
                data: {
                    requestFrom: 'Sidebar Download Brochure'
                },
                success: function (data) {
                    var dealersListHtml = data.innerHTML || 'Unable to get Dealers List';
                    var userloc = JSON.parse(frontendUtils.getCookie('userloc') || 'null');
                    $sidebarLocationList.html(dealersListHtml);

                    if (userloc && userloc.dealer && userloc.dealer.dealerId) {
                        $sidebarLocationList
                            .find('#' + userloc.dealer.dealerId)
                            .prop('checked', true)
                        ;
                    } else if (data.stores?.length > 0) {
                        var userDealer = {
                            dealerId: data.stores[0].ID,
                            dealerName: data.stores[0].name,
                            portId: data.stores[0].portId,
                            expertId: data.stores[0].expertNo
                        };
                        $('body').trigger('stores:updateLocationWithPortDealer', userDealer);
                    }
                }
            });
        },
        initBrochureEvents: function () {

            $('#brochure-details-form input, #brochure-details-form select').on('input change', function () {
                var $input = $(this);
                var $errorFeedback = $input.siblings('.invalid-feedback');
                if ($errorFeedback.length) {
                    $input.removeClass('is-invalid');
                }
            });

            $(document).on("click", ".car-card.selectable", function (e) {
                var $clickedCard = $(this);
                // Determine which modal the card belongs to and the corresponding
                // form section. Scoping is required because both forms reuse the
                // same class names for preview containers
                // (.sidebar__brochure__select-car__selected-cars, etc.), so updating
                // globally would pollute the other form's preview with the wrong
                // models (e.g. Civic Type R is in brochure modal but filtered out
                // of the test drive modal by `isNotEligibleForTestDrive`).
                var $modal = $clickedCard.closest('.modal');
                var modalId = $modal.attr('id');
                var formSectionSelector;
                if (modalId === 'sidebarBrochure') {
                    formSectionSelector = '#sidebarDownloadBrochure';
                } else if (modalId === 'sidebarTestDriveModal') {
                    formSectionSelector = '#sidebarTestDrive';
                } else {
                    return;
                }
                var $formSection = $(formSectionSelector);
                if (!$formSection.length) {
                    return;
                }

                var maxAllowed = 3;
                var selectedCount = $modal.find('.car-card.is-selected').length;
                var updateSelectedView = false;
                if (selectedCount <= (maxAllowed - 1)) {
                    $clickedCard.toggleClass('is-selected');
                    updateSelectedView = true;
                } else if ($clickedCard.hasClass('is-selected') && selectedCount == maxAllowed) {
                    $clickedCard.toggleClass('is-selected');
                    updateSelectedView = true;
                }

                if (updateSelectedView === true) {
                    var carData = $modal.find('.car-data-object').data('cardata');
                    let progressHtml = '';
                    var $modalSelectedCards = $modal.find('.car-card.is-selected');
                    var currSelCount = $modalSelectedCards.length;
                    var $noCarModelImg = $modal.find('.no-car-model-img');

                    for (let i = 1; i <= currSelCount; i++) {
                        var $selectCar = $modalSelectedCards[i - 1];
                        var selectCarId = $($selectCar).data('productid');
                        var currImage = "";
                        var currCar = carData.find(
                            (product) => product.productName === $($selectCar).data('productname')
                        );


                        if (typeof currCar.Image == "string") {
                            currImage = currCar.Image;
                        } else if ($noCarModelImg.length) {
                            currImage = $noCarModelImg[0].src;
                        }

                        progressHtml += `<div class="form-selected-car col-6 col-sm-4">
                            <div class="car-items">
                                <div class="car-item">
                                    <img src="${currImage}" class="clickable" />
                                    <div class="mb-3">${currCar.productName}</div>
                                </div>
                            </div>
                        <div class="grade-options">`;
                        currCar.gradeArray.forEach((item, index) => {
                            progressHtml += `<div class="form-group col-12 text-left custom-control custom-radio">
                                    <input type="radio" class="form-check-input" data-productid=${selectCarId} required value="${item.id}" id="car-selected-${item.id}" name="car-selected-radio-${i}" ${index == 0 ? 'checked' : ''}>
                                    <label class="form-control-label" for="car-selected-radio-${i}">${item.displayValue}</label>
                                </div>`;
                        });
                        progressHtml += `</div></div>`;
                    }
                    $formSection.find('.sidebar__brochure__select-car__selected-cars').html('');
                    if (currSelCount > 0) {
                        $formSection.find('.sidebar__brochure__select-car__toggle').hide();
                        $formSection.find('.sidebar__brochure__select-car__selected-cars').html(progressHtml);
                        $formSection.find('.modal-selection-error, .select-car-error').addClass('d-none').removeClass('d-flex');
                        $formSection.find('.sidebar__brochure__select-car__text-toggle').show();
                    } else {
                        $formSection.find('.sidebar__brochure__select-car__toggle').show();
                        $formSection.find('.sidebar__brochure__select-car__text-toggle').hide();
                    }
                }
            });

            var $form = $('#brochure-details-form');
            var $currSection = $('#sidebarDownloadBrochure');

            $form.on('submit', function (e) {
                e.preventDefault();
            });

            $(document).on("click", ".form-selected-car .text-left", function (e) {
                let $radio;
                if ($(this).is('input[type="radio"]')) {
                    $radio = $(this);
                } else {
                    $radio = $(this).find('input[type=radio]');
                }
                let groupName = $radio.attr('name');
                $('input[name="' + groupName + '"]').prop('checked', false);
                $radio.prop('checked', true);
            });

            $(document).on("click", ".download-brochure-button", function (e) {
                // Scope to the brochure modal only — the click handler scopes
                // selection per-modal, so the submit must do the same to avoid
                // leaking a preselected showroom card from the test drive modal
                // into the brochure payload (results in a duplicate model with
                // Grade=undefined because the brochure form only renders radios
                // for its own selected cards).
                var $brochureModal = $('#sidebarBrochure');
                var $brochureSelectedCards = $brochureModal.find('.car-card.is-selected');
                var currSelCount = $brochureSelectedCards.length;

                var emailInput = $form.find('#details-form-email');
                var emailValue = emailInput.val();
                var emailPattern = /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,6}$/;

                if (currSelCount < 1) {
                    $('.select-car-error').removeClass('d-none').addClass('d-flex');

                    if ($('.select-car-error').hasClass('d-flex')) {
                        scrollUtils.scrollToElement('#brochure-details-form');
                    }
                }
                scrollUtils.scrollToFirstInvalidField('#brochure-details-form');

                if (!emailPattern.test(emailValue)) {
                    $('#details-form-email-error').text('Please enter a valid email address');
                    emailInput.addClass('is-invalid');
                    scrollUtils.scrollToFirstInvalidField('#brochure-details-form');
                    return;
                } else {
                    $('#details-form-email-error').text('');
                    emailInput.removeClass('is-invalid');
                }

                var data = $form.serializeArray();
                var location = data.find((item) => item.name === "user-location-dealers");
                if (!location) {
                    $('.postal-code-error').removeClass('d-none');
                }

                if ($form.get(0).checkValidity() && currSelCount > 0 && location) {
                    var url = $form.attr('action');
                    var userloc = frontendUtils.getCookie('userloc') || '{}';
                    var userLocation = JSON.parse(userloc);
                    var postData = $form.serializeArray();
                    var carData = $brochureModal.find('.car-data-object').data('cardata');
                    var varPreferredModels = [];

                    for (let i = 1; i <= currSelCount; i++) {
                        var $selectCar = $brochureSelectedCards[i - 1];
                        var selectCarId = $($selectCar).data('productid');
                        var currCar = carData.find(
                            (product) => product.productName === $($selectCar).data('productname')
                        );
                        var selGrade = $form.find('input[name="car-selected-radio-' + i + '"]:checked').val();
                        var currPreferred = {
                            "Model": currCar.Model,
                            "Year": currCar.Year,
                            "Grade": selGrade,
                            "Door": currCar.Door,
                            "Colour": "String",
                            "productId": selectCarId
                        };
                        varPreferredModels.push(currPreferred);
                    }

                    var formData = {
                        "PreferredModels": varPreferredModels,
                        "ContactDetails": {
                            "Title": postData.find((product) => product.name === "detailsTitle").value,
                            "FirstName": postData.find((product) => product.name === "detailsFirstName").value,
                            "Surname": postData.find((product) => product.name === "detailsLastName").value,
                            "Email": postData.find((product) => product.name === "detailsEmail").value,
                            "Mobile": postData.find((product) => product.name === "detailsPhone").value,
                            "PrivacyConsent": $form.find('#brochure-when-consent').is(":checked"),
                            "AddressPostcode": userLocation.postalCode,
                            "DealerId": postData.find((product) => product.name === "user-location-dealers").value,
                            "expertId": $form.find('input[name="user-location-dealers"]:checked').data('expertid') + ''
                        },
                        "possiblePurchase": $form.find('input[name="brochure-when"]:checked').val(),
                        "MetaEventId": window.sidenavBrochureUUID || '',
                        "GACLIENTID": analyticsHelper.getGAClientId(),
                        "GATRACKID": analyticsHelper.getGATrackId(),
                        "GAUSERID": analyticsHelper.getGAUserId(),
                        "GUID": analyticsHelper.getGAGUID()
                    };
                    $('#page-sidebar').spinner().start();

                    $('body').trigger('download.brochure.beforeLead');
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: JSON.stringify(formData),
                        success: function (data) {
                            $('#page-sidebar').spinner().stop();
                            if (!data.error) {
                                var buttonHTML = "";
                                data.brochureLinks.forEach((item, index) => {
                                    buttonHTML += `<span class="d-block mt-2 ">
                                        <a target="_blank" class="btn btn-primary w-100" href="${item.BrochurePDFLink}">View ${item.ProductName} brochure</a>
                                    </span>`;
                                });

                                $currSection.find('.form-box').hide();
                                $currSection.find('.form-box-confirmation').show();
                                $currSection.find('.form-box-confirmation-list').html(buttonHTML);
                            } else {
                                $("#downlod-brochure-error").show();
                            }
                            $('body').trigger('download.brochure.afterLead.success', data);
                        },
                        error: function (data) {
                            $('#page-sidebar').spinner().stop();
                            $('.text-download-error-message-text').text(data.responseJSON.message);
                            $('.download-error-message').removeClass('d-none');
                            scrollUtils.scrollToElement('.text-download-error-message-text');
                            $('body').trigger('download.brochure.afterLead.error', data);
                        }
                    });
                } else if (currSelCount < 1) {
                    $('.select-car-error').removeClass('d-none');
                }
            });

            $('body').on('click', '#downloadBrochureConfirm', function () {
                $('#sidebarDownloadBrochure').collapse('hide');
                $(this).parents('.page-sidebar__content').find('.invalid-feedback').html('');
                var $currSection = $(this).parents('.page-sidebar__content');
                if ($currSection.length) {
                    $currSection.find('form').get(0).reset();
                    $currSection.find('.form-box').show();
                    $currSection.find('.form-box-confirmation').hide();
                    $currSection.find('.form-box-confirmation-list').html('');
                }
                $('.sidebar__brochure__select-car__selected-cars').html('');
                $('.sidebar__brochure__select-car__toggle').show();
                $('.sidebar__brochure__select-car__text-toggle').hide();
                $('.car-card.selectable').removeClass('is-selected');

                sidebar.testDriveCreate.preselectShowroomModel();

                if (window.innerWidth < BREAKPOINTS.sm) {
                    $('#sg-navbar-toggle').click();
                } else {
                    $('#page-sidebar-collapse').collapse('hide');
                }
            });

            $('body').on('click', '#downloadAnotherBrochure', function (e) {
                e.preventDefault();
                var $currSection = $(this).parents('.page-sidebar__content');
                $(this).parents('.page-sidebar__content').find('.invalid-feedback').html('');
                if ($currSection.length) {
                    $currSection.find('form').get(0).reset();
                    $currSection.find('.form-box').show();
                    $currSection.find('.form-box-confirmation').hide();
                    $currSection.find('.form-box-confirmation-list').html('');
                }
                $('.sidebar__brochure__select-car__selected-cars').html('');
                $('.sidebar__brochure__select-car__toggle').show();
                $('.sidebar__brochure__select-car__text-toggle').hide();
                $('.car-card.selectable').removeClass('is-selected');
            });

            $('body').on('click', '#sidebar-download-brochure', function () {
                if (window.location.hash !== '#!/brochure') {
                    window.location.hash = '#!/brochure';
                } else {
                    window.location.hash = '#!';
                }
            });

            var $isHomePage = $('#show-offline-order-modal');
            if ($isHomePage.length > 0) {
                $(document).on("click", "#load-my-build-cta", function () {
                    var params = new URLSearchParams(window.location.search);
                    var uniqueCodeInUrl = params.get('code') || '';
                    var userId = params.get('userId') || '';
                    var sessionId = params.get('sessionId') || '';
                    var orderId = params.get('orderId') || '';
                    var dealerCode = params.get('dealerCode') || '';
                    var modifyCar = params.get('modifyCar') || '';
                    var modifyAccessories = params.get('modifyAccessories') || '';
                    var action = params.get('action') || '';
                    var showroomStock = params.get('showroomStock') || '';
                    var sameVin = params.get('sameVin') || '';
                    var relatedRecordType = params.get('relatedRecordType') || '';
                    var uniqueIdOnline = $('#build-unique-code').val();
                    var $uniqueBuildId;
                    var $uniqueBuildIdLen;
                    if (uniqueCodeInUrl) {
                        $uniqueBuildId = uniqueCodeInUrl;
                        $uniqueBuildIdLen = uniqueCodeInUrl.length;
                    } else {
                        $uniqueBuildId = uniqueIdOnline;
                        $uniqueBuildIdLen = $uniqueBuildId.replace(/\s/g, '').length;
                    }
                    if ($uniqueBuildIdLen != 6) {
                        $('#build-unique-code-input').addClass('unique-code-input-error');
                        $('.unique-code-invalid-feedback').addClass('d-flex').removeClass('d-none');

                    } else {
                        var modalContent = $('#configurator-load-a-build-modal .modal-content');
                        var url = $('#configurator-load-a-build-modal').data('action');
                        var formData = {
                            uniqueBuildId: $uniqueBuildId,
                            loadFromHomePage: true,
                            userId: userId,
                            sessionId: sessionId,
                            orderId: orderId,
                            modifyCar: modifyCar,
                            modifyAccessories: modifyAccessories,
                            action: action,
                            showroomStock: showroomStock,
                            sameVin: sameVin,
                            relatedRecordType: relatedRecordType,
                            dealerCode: dealerCode
                        }
                        modalContent.spinner().start();
                        $.ajax({
                            url: url,
                            type: 'post',
                            dataType: 'json',
                            data: formData,
                            success: function (response) {
                                modalContent.spinner().stop();
                                if (response.result.success) {
                                    var redirectUrl = response.redirectURL;
                                    var url = new URL(redirectUrl);
                                    redirectUrl = redirectUrl.replace('&showSummary=true', '');
                                    var orderId = url.searchParams.get('orderId');
                                    var variantGrade = url.searchParams.get('v');
                                    var variantColor = url.searchParams.get('sv');
                                    var carModel = url.pathname.split('/').pop().split('.')[0];
                                    if (orderId && variantGrade && variantColor && carModel) {
                                        var variantObj = { variant: variantGrade, variantColor: variantColor, carModel: carModel };
                                        sessionStorage.setItem('modifySelectedOrderVariant', JSON.stringify(variantObj));
                                    }
                                    if (response.orderLocation) {
                                        frontendUtils.setCookie('userloc', response.orderLocation);
                                    }

                                    window.location.href = redirectUrl;
                                } else {
                                    $('.unique-code-invalid-feedback').addClass('d-flex').removeClass('d-none');
                                    $('#build-unique-code-input').addClass('unique-code-input-error');
                                }
                            },
                            error: function () {
                                modalContent.spinner().stop();
                                $('.unique-code-invalid-feedback').addClass('d-flex').removeClass('d-none');
                                $('#build-unique-code-input').addClass('unique-code-input-error');
                            }
                        });
                    }
                });
            }
        }
    },
    location: {
        initLocationEvents: function () {
            let $allSidebarEditLocationSummary = $('.sidebar-edit-location-summary');

            $('body').on('click', '.sidebar-edit-location', function () {
                let $this = $(this);
                let $userLocation = $this.closest('.user-location');
                window.sidebar.elements.$userLocationInput = $userLocation.children('.user-location-input');
                window.sidebar.elements.$userLocationSummary = $userLocation.children('.user-location-summary');
                window.sidebar.elements.$userLocationSummary.removeClass('d-flex');
                window.sidebar.elements.$userLocationSummary.addClass('d-none');
                window.sidebar.elements.$userLocationInput.removeClass('d-none');
                window.sidebar.elements.$userLocationInput.addClass('d-flex');

                $('.sidebar-brochure-section #configurator-location-error-msg').removeClass('d-flex').addClass('d-none');
                $('.sidebar-location-section #configurator-location-error-msg').removeClass('d-flex').addClass('d-none');
                $('.sidebar-location-selection-section #configurator-location-error-msg').removeClass('d-flex').addClass('d-none');
                $('.configurator-location__form #user-location-input-invalid').removeClass('d-flex').addClass('d-none');
            });

            $('body').on('location:afterUpdate', function (el, data) {

                if (data.cookieID === 'userloc') {
                    let userLocation = JSON.parse(frontendUtils.getCookie(data.cookieID) || 'null');

                    if (!userLocation) {
                        return;
                    }

                    $allSidebarEditLocationSummary.each(function () {
                        let $this = $(this);
                        var $userLocationSummary = userLocation.summary;
                        if ($this.hasClass('sidebar-location')) {
                            $userLocationSummary = `<span class="color--nutral-90">Location: </span> ${$userLocationSummary}`;
                        }
                        $this.html($userLocationSummary);
                    });


                    let $allUserLocation = $('.user-location');
                    $allUserLocation.each(function () {
                        let $userLocation = $(this);
                        let $userLocationInput = $userLocation.children('.user-location-input');
                        let $userLocationSummary = $userLocation.children('.user-location-summary');
                        $userLocationInput.removeClass('d-flex');
                        $userLocationInput.addClass('d-none');
                        $userLocationSummary.addClass('d-flex');
                    });

                    window.sidebar.downloadBrochure.initGetDealers();
                }
            });
            $('body').on('click', '#side-navigation-menu-location', function () {
                if (window.location.hash !== '#!/location') {
                    window.location.hash = '#!/location';
                } else {
                    window.location.hash = '#!';
                }
            });
        }
    },
    testDriveCreate: {
        initTestDriveEvents: function () {

                        $('#create-test-drive-form input, #create-test-drive-form select').on('input change', function () {
                var $input = $(this);
                var $errorFeedback = $input.siblings('.invalid-feedback');
                if ($errorFeedback.length) {
                    $input.removeClass('is-invalid');
                }
            });

            var $form = $('#create-test-drive-form');
            var $currSection = $('#sidebarTestDrive');

            $form.on('submit', function (e) {
                e.preventDefault();
            });

            $(document).on("click", ".create-Test-Drive-button", function (e) {
                var userloc = frontendUtils.getCookie('userloc') || '{}';
                var userLocation = JSON.parse(userloc);
                // Scope to the test drive modal only — see brochure submit
                // handler comment for rationale.
                var $testDriveModal = $('#sidebarTestDriveModal');
                var $testDriveSelectedCards = $testDriveModal.find('.car-card.is-selected');
                var currSelCount = $testDriveSelectedCards.length;

                var emailInput = $form.find('#details-test-drive-form-email');
                var emailValue = emailInput.val();
                var emailPattern = /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,6}$/;

                if (currSelCount < 1) {
                    $('.modal-selection-error').removeClass('d-none').addClass('d-flex');

                    if ($('.modal-selection-error').hasClass('d-flex')) {
                        scrollUtils.scrollToElement('#create-test-drive-form');
                    }
                }
                scrollUtils.scrollToFirstInvalidField('#create-test-drive-form');

                if (!emailPattern.test(emailValue)) {
                    $('#details-test-drive-form-email-error').text('Please enter a valid email address');
                    emailInput.addClass('is-invalid');
                    scrollUtils.scrollToFirstInvalidField('#create-test-drive-form');
                    return;
                } else {
                    $('#details-test-drive-form-email-error').text('');
                    emailInput.removeClass('is-invalid');
                }
                var data = $form.serializeArray();
                var location = data.find((item) => item.name === "user-location-dealers");
                if (!location) {
                    $('.postal-code-error').removeClass('d-none');
                }

                if ($form.get(0).checkValidity() && currSelCount > 0 && location) {
                    var url = $form.attr('action');
                    var postData = $form.serializeArray();
                    var carData = $testDriveModal.find('.car-data-object').data('cardata');
                    var varPreferredModels = [];

                    for (let i = 1; i <= currSelCount; i++) {
                        var $selectCar = $testDriveSelectedCards[i - 1];
                        var selectCarId = $($selectCar).data('productid');
                        var currCar = carData.find(
                            (product) => product.productName === $($selectCar).data('productname')
                        );
                        var selGrade = $form.find('input[name="car-selected-radio-' + i + '"]:checked').val();
                        var currPreferred = {
                            "Model": currCar.Model,
                            "Year": currCar.Year,
                            "Grade": selGrade,
                            "Door": currCar.Door,
                            "Colour": "String",
                            "productId": selectCarId
                        };
                        varPreferredModels.push(currPreferred);
                    };


                    var formData = {
                        "PreferredModels": varPreferredModels,
                        "ContactDetails": {
                            "Title": postData.find((product) => product.name === "detailsTestDriveTitle").value,
                            "FirstName": postData.find((product) => product.name === "detailsTestDriveFirstName").value,
                            "Surname": postData.find((product) => product.name === "detailsTestDriveLastName").value,
                            "Email": postData.find((product) => product.name === "detailsTestDriveEmail").value,
                            "Mobile": postData.find((product) => product.name === "detailsTestDrivePhone").value,
                            "PrivacyConsent": $form.find('#test-drive-when-consent').is(":checked"),
                            "AddressPostcode": userLocation.postalCode,
                            "DealerId": postData.find((product) => product.name === "user-location-dealers").value,
                            "expertId": $('#sidebarTestDrive').find('input[name="user-location-dealers"]:checked').data('expertid') + ''
                        },
                        "MetaEventId": window.sidenavTestDriveUUID || '',
                        "GACLIENTID": analyticsHelper.getGAClientId(),
                        "GATRACKID": analyticsHelper.getGATrackId(),
                        "GAUSERID": analyticsHelper.getGAUserId(),
                        "GUID": analyticsHelper.getGAGUID()
                    };
                    $('#page-sidebar').spinner().start();
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: JSON.stringify(formData),
                        success: function (data) {
                            $('#page-sidebar').spinner().stop();
                            if (!data.error) {
                                $currSection.find('.form-box').hide();
                                $currSection.find('.form-box-confirmation').show();
                                $('body').trigger('testdrive.afterLead.success', data);
                            }
                        },
                        error: function (data) {
                            $('#page-sidebar').spinner().stop();
                            $('.text-drive-error-message-text').text(data.responseJSON.message);
                            $('.testdrive-error-message').removeClass('d-none');
                            scrollUtils.scrollToElement('.testdrive-error-message');
                        }
                    });
                } else {
                    if (currSelCount < 1) {
                        $('.modal-selection-error').removeClass('d-none').addClass('d-flex');
                    }
                }
            });

            $('body').on('click', '#testDriveConfirm', function () {
                var $currSection = $(this).parents('.page-sidebar__content');
                $('#sidebarTestDrive').collapse('hide');
                $(this).parents('.page-sidebar__content').find('.invalid-feedback').html('');
                $currSection.find('form').get(0).reset();
                $currSection.find('.form-box').show();
                $currSection.find('.form-box-confirmation').hide();
                $('.sidebar__brochure__select-car__selected-cars').html('');
                $('.sidebar__brochure__select-car__toggle').show();
                $('.sidebar__brochure__select-car__text-toggle').hide();
                $('.car-card.selectable').removeClass('is-selected');

                sidebar.testDriveCreate.preselectShowroomModel();

                if (window.innerWidth < BREAKPOINTS.sm) {
                    $('#sg-navbar-toggle').click();
                } else {
                    $('#page-sidebar-collapse').collapse('hide');
                }
            });

            $('#laod-previous-build-cta').on('click', () => {
                $('#selectCarModal').modal('hide');
                setTimeout(() => $('#configurator-load-a-build-modal').modal('show'), 5);
            });

            $(document).on("click", ".btn-test-drive-select", function (e) {
                sidebar.testdrivetriggers();
            });

            $('body').on('click', '#sidebar-testDrive', function () {
                if (window.location.hash !== '#!/testdrive') {
                    window.location.hash = '#!/testdrive';
                } else {
                    window.location.hash = '#!';
                }
            });
        },
        preselectShowroomModel: function () {
            var productId = $('.js-current-showroom-model').first().attr('data-product-id');
            if (!productId) {
                return;
            }

            $('#sidebarBrochure .car-card.selectable[data-productid="' + productId + '"]')
                .not('.is-selected')
                .first()
                .trigger('click');

            $('#sidebarTestDriveModal .car-card.selectable[data-productid="' + productId + '"]')
                .not('.is-selected')
                .first()
                .trigger('click');
        }
    },
    uniqueCodeInputFill: function () {
        const inputs = document.querySelectorAll("#build-unique-code-input input[type=text]");
        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            input.addEventListener("input", function () {

                if (input.value.length == 1 && i + 1 < inputs.length) {
                    inputs[i + 1].focus();
                }
                if (input.value.length > 1) {
                    const chars = input.value.split('');

                    for (let pos = 0; pos < chars.length; pos++) {
                        if (pos + i >= inputs.length) break;
                        let targetInput = inputs[pos + i];
                        targetInput.value = chars[pos];
                    }

                    let focus_index = Math.min(inputs.length - 1, i + chars.length);
                    inputs[focus_index].focus();
                }
                updateInput();
            });

            input.addEventListener("keydown", function (e) {
                if (e.keyCode == 8 && input.value == '' && i != 0) {
                    for (let pos = i; pos < inputs.length - 1; pos++) {
                        inputs[pos].value = inputs[pos + 1].value;
                    }

                    inputs[i - 1].value = '';
                    inputs[i - 1].focus();
                    updateInput();
                    return;
                }

                if (e.keyCode == 46 && i != inputs.length - 1) {
                    for (let pos = i; pos < inputs.length - 1; pos++) {
                        inputs[pos].value = inputs[pos + 1].value;
                    }

                    inputs[inputs.length - 1].value = '';
                    input.select();
                    e.preventDefault();
                    updateInput();
                    return;
                }

                if (e.keyCode == 37) {
                    if (i > 0) {
                        e.preventDefault();
                        inputs[i - 1].focus();
                        inputs[i - 1].select();
                    }
                    return;
                }

                if (e.keyCode == 39) {
                    if (i + 1 < inputs.length) {
                        e.preventDefault();
                        inputs[i + 1].focus();
                        inputs[i + 1].select();
                    }
                    return;
                }
            });
        }

        function updateInput() {
            let inputValue = Array.from(inputs).reduce(function (otp, input) {
                otp += (input.value.length) ? input.value : ' ';
                return otp;
            }, "");
            document.querySelector("input[name=build-unique-code]").value = inputValue;
        }
    },
    brochureurltriggers: function () {
        if (!document.getElementById('page-sidebar')) {
            return;
        }

        const sidebarOpenBtn = document.querySelector('button[aria-controls="page-sidebar-collapse"]');
        if (window.innerWidth < BREAKPOINTS.sm) {
            // Only click if mobile-navbar-toggler is visible (sidebar not yet open)
            if (!$('.mobile-navbar-toggler').hasClass('d-none')) {
                $('.mobile-navbar-toggler').click();
            }
        } else {
            sidebarOpenBtn.click();
        }

        const downloadBrochurebtn = document.querySelector('button[aria-controls="sidebarDownloadBrochure"]');
        if (downloadBrochurebtn.classList.contains('collapsed')) {
            downloadBrochurebtn.click();
        }

        if (window.innerWidth < BREAKPOINTS.sm) {
            sidebarDownloadBrochureHeading.scrollIntoView();
        } else {
            scrollUtils.scrollToElement('#sidebarDownloadBrochure');
        }
    },

    testdrivetriggers: function () {
        if (!document.getElementById('page-sidebar')) {
            return;
        }

        const sidebarOpenBtn = document.querySelector('button[aria-controls="page-sidebar-collapse"]');
        if (window.innerWidth < BREAKPOINTS.sm) {
            // Only click if mobile-navbar-toggler is visible (sidebar not yet open)
            if (!$('.mobile-navbar-toggler').hasClass('d-none')) {
                $('.mobile-navbar-toggler').click();
            }
        } else {
            sidebarOpenBtn.click();
        }

        const testDrivebtn = document.querySelector('button[aria-controls="sidebarTestDrive"]');
        if (testDrivebtn.classList.contains('collapsed')) {
            testDrivebtn.click();
        }

        if (window.innerWidth < BREAKPOINTS.sm) {
            sidebarTestDriveCardHeading.scrollIntoView();
        } else {
            scrollUtils.scrollToElement('#sidebarTestDrive');
        }
    },
    locationtrigger: function () {
        if (!document.getElementById('page-sidebar')) {
            return;
        }

        const sidebarOpenBtn = document.querySelector('button[aria-controls="page-sidebar-collapse"]');
        sidebarOpenBtn.click();

        const locationbtn = document.querySelector('button[aria-controls="sidebarLocation"]');
        locationbtn.click();

        scrollUtils.scrollToElement('#sidebarLocation');
    },
    updateTabLocation: function () {
        if (tabIdentity.isTabIsolation()) {
            $('body').trigger('location:afterUpdate', { cookieID: 'userloc' });
        } else {
            this.downloadBrochure.initGetDealers();
        }
    },
    init: function () {
        this.location.initLocationEvents();
        this.downloadBrochure.initBrochureEvents();
        this.testDriveCreate.initTestDriveEvents();
        this.testDriveCreate.preselectShowroomModel();
        this.uniqueCodeInputFill();
        this.updateTabLocation();

        observeSidebarLocationToggle();
        handleSidebarLocationInputforbrochure();
        handleSidebarUserLocationInputValidation();
    }
};

function handleSidebarLocationInputforbrochure() {

    $('.sidebar-location-selection-section #sidebar-useMyLocation').on('click', function () {
        setTimeout(function () {
            var locationInputValue = $('.sidebar-location-selection-section #sidebar-configurator-google-autocomplete').val();
            var $apiError = $('.sidebar-location-selection-section #configurator-location-error-msg');

            if (!locationInputValue) {
                $apiError.addClass('d-flex');
            } else {
                $apiError.removeClass('d-flex');
            }
        }, 1500);
    });

    $('.htooltip').on('mouseover', function (n) {
        var httContent = document.getElementById('htooltip__content'),
            o = document.querySelector(".page-sidebar__tools"),
            i = 0,
            s = $(this).offset().top;
        httContent.style.top = s + 1 + "px";
        httContent.style.opacity = 1;
        httContent.style.transform = "translateX(" + i + "px)";
        httContent.style.webkitTransform = "translateX(" + i + "px)";
        httContent.style.msTransform = "translateX(" + i + "px)";
        httContent.innerHTML = $(this).find('.icon').data('htt-text');
    });

    $('.htooltip').on('mouseout', function (n) {
        var httContent = document.getElementById('htooltip__content');
        httContent.removeAttribute("style");
    });
}

function observeSidebarLocationToggle() {
    const sidebarLocation = document.getElementById('sidebarLocation');
    const iconLocation = document.querySelector('#sidebarLocationHeading .icon-location');

    if (sidebarLocation && iconLocation) {
        $('#sidebarLocation').on('shown.bs.collapse', function () {
            iconLocation.classList.add('--icon-primary');
        });

        $('#sidebarLocation').on('hidden.bs.collapse', function () {
            iconLocation.classList.remove('--icon-primary');
        });
    }
}

function openProductListModal() {
    var $showModal = $('#show-offline-order-modal');
    // `#show-offline-order-modal` is on `page.isml` (homepage + PDP). Skip Product-Show so
    // dealer Opportunity links do not re-open Build & Price after the car was already chosen.
    var isConfiguratorPage = document.querySelector('.page[data-action="Product-Show"]');

    if ($showModal.length > 0 && !isConfiguratorPage) {
        var urlParams = new URLSearchParams(window.location.search);
        var openProductModal = urlParams.get('relatedRecordType');
        var code = urlParams.get('code') || '';
        if ((openProductModal == 'Lead' || openProductModal == 'Opportunity') && code == '') {
            $('#selectCarModal').modal({
                show: true,
                backdrop: 'static',
                keyboard: false
            });
            $('#selectCarModal').find('.close.modal-close-button').removeAttr('data-dismiss');
            var params = new URLSearchParams(window.location.search);
            params.set('openLocationModal', 'true');
            var paramString = params.toString();
            $('#selectCarModal').find('a.redirect-cta').each(function () {
                var $link = $(this);
                var orignalHref = $link.attr('href');
                if (!orignalHref.includes(paramString)) {
                    var updateHref = orignalHref.includes('?') ?
                        orignalHref + '&' + paramString :
                        orignalHref + '?' + paramString
                    $link.attr('href', updateHref);
                }
            });
            var userLocCookies = frontendUtils.getCookie('userloc');
            if (userLocCookies) {
                frontendUtils.deleteCookie('userloc');
            }
        }
    }
}

function updateRedirectLinksWithOrderParams() {
    var $modal = $('#selectCarModal');
    var $links = $modal.find('a.redirect-cta');
    if (!$links.length) return;
    var urlParams = new URLSearchParams(window.location.search);
    var keysToAppend = ['orderId', 'modifyCar', 'action', 'dealerCode', 'userId', 'sessionId', 'showroomStock'];
    var filteredParams = new URLSearchParams();
    for (var i = 0; i < keysToAppend.length; i++) {
        var key = keysToAppend[i];
        var value = urlParams.get(key);
        if (value) {
            filteredParams.set(key, value);
        }
    }

    if (!(filteredParams.get('orderId') && (filteredParams.get('modifyCar') || filteredParams.get('action')))) {
        return;
    }
    $links.each(function () {
        var $link = $(this);
        var originalHref = $link.attr('href') || '';
        var hasQuery = originalHref.indexOf('?') !== -1;
        var separator = hasQuery ? '&' : '?';
        var newHref = originalHref + separator + filteredParams.toString();
        $link.attr('href', newHref);
    });
}

function configuratorUpdateCarModelModalUrl() {
    var $updateModalUrl = $('.configurator-modal');
    if ($updateModalUrl.length > 0) {
        var urlParams = new URLSearchParams(window.location.search);
        var openProductModal = urlParams.get('relatedRecordType');
        var code = urlParams.get('code') || '';
        if ((openProductModal == 'Lead' || openProductModal == 'Opportunity')) {
            var params = new URLSearchParams(window.location.search);
            params.delete('camp');
            params.delete('m');
            params.delete('v');
            params.delete('sv');
            params.delete('accpk');
            params.delete('acc');
            params.delete('mem');
            var paramString = params.toString();
            $('#selectCarModal').find('a.redirect-cta').each(function () {
                var $link = $(this);
                var orignalHref = $link.attr('href');
                if (!orignalHref.includes(paramString)) {
                    var updateHref = orignalHref.includes('?') ?
                        orignalHref + '&' + paramString :
                        orignalHref + '?' + paramString
                    $link.attr('href', updateHref);
                }
            });
        }
    }
}

function populateLocationInfo(userLocationSummary) {
    $('#configurator-footer-location-summary').html(userLocationSummary);
    configurator.header.populateDriveAwayPrice();

    var userLocation = JSON.parse(frontendUtils.getCookie('userloc'));
    frontendUtils.updateUrlParams({
        'suburb': userLocation.city,
        'pc': userLocation.postalCode,
        'state': userLocation.state.code
    });
}

function handleSidebarUserLocationInputValidation() {

    var $input = $('.location-input-sidebar-field');
    var $inputInvalid = $('.user-input-location-invalid');

    if (!$input.val()) {
        $inputInvalid.addClass('d-none');
    }

    $('.sidebar-location-selection-section .location-input-sidebar-field').on('keyup', function () {
        var regex = /(?:\D*\d){5,}/;
        var $input = $(this);

        var $parentContainer = $input.closest('.user-location-input');
        var $inputInvalid = $parentContainer.find('.user-input-location-invalid');
        var $inputInvalidMsg = $parentContainer.find('.sidebar-google-autocomplete-invalid');
        var $locationError = $parentContainer.find('.configurator-location-error-msg');

        $inputInvalid.addClass('d-none');
        $locationError.addClass('d-none');

        if (!$input.val()) {
            $inputInvalidMsg.text($inputInvalid.data('empty'));
            $inputInvalid.removeClass('d-none').addClass('d-flex pt-2');
            $input.trigger('focus');
            return false;
        }

        if ($input.val().length < 3) {
            $inputInvalidMsg.text($inputInvalid.data('invalid'));
            $inputInvalid.removeClass('d-none').addClass('d-flex pt-2');
            $input.trigger('focus');
            return false;
        }

        if (regex.test($input.val())) {
            $inputInvalidMsg.text($inputInvalid.data('invalid'));
            $inputInvalid.removeClass('d-none').addClass('d-flex pt-2');
            $input.trigger('focus');
            return false;
        }

        $inputInvalid.addClass('d-none');
        $locationError.addClass('d-none');
    });
}

function populateDealersInfo() {
    let userLocation = null;
    userLocation = JSON.parse(frontendUtils.getCookie('userloc'));
    var $configuratorTestDriveForm = $('#configurator-test-drive-form');
    if (userLocation.dealer) {
        $(`#configurator-location-confirm`).removeAttr('disabled');
        $('#configurator-footer-dealer-name').html(userLocation.dealer.dealerName);
        $configuratorTestDriveForm.find('#sidebar-edit-location-summary').html(userLocation.summary);
        $configuratorTestDriveForm.find('#user-location-summary').addClass('d-flex');
        $configuratorTestDriveForm.find('#user-location-input').removeClass('d-flex').addClass('d-none');
    }
}

function openLoadBuildMoal() {
    var $showModal = $('#show-offline-order-modal');
    // Homepage CXP (code + userId) should prompt once. After Load my build the
    // redirect keeps those params (add-new config has no orderId), so skip
    // Product-Show — same as openProductListModal / update-order (no re-open
    // on configurator or summary).
    var isConfiguratorPage = document.querySelector('.page[data-action="Product-Show"]');

    if ($showModal.length > 0 && !isConfiguratorPage) {
        var params = new URLSearchParams(window.location.search);
        var code = params.get('code') || '';
        var userId = params.get('userId') || '';
        if (code != '' && userId != '') {
            $('#configurator-load-a-build-modal').modal('show');
            $('#build-unique-code-input input').each(function (index) {
                $(this).val(code.charAt(index)).prop('disabled', true);
            });
        }
    }
}

$(() => {
    sidebar.init();

    if (window.innerWidth < BREAKPOINTS.sm) {
        $('#page-sidebar-collapse-btn').removeAttr('data-toggle');
        frontendUtils.moveContents('page-sidebar-lg', 'page-sidebar-mobile');
    }

    function checkUrlAndTrigger() {
        if (window.location.hash === '#brochure') {
            sidebar.brochureurltriggers();
        } else if (window.location.hash === '#testdrive') {
            sidebar.testdrivetriggers();
        }
        if (window.location.hash === '#build-your-honda') {
            $('#selectCarModal').modal('show');
        }
        if (window.location.hash === '#location') {
            sidebar.locationtrigger();
        }
    }

    $('#selectCarModal').on("hidden.bs.modal", function () {
        if (window.location.hash === '#build-your-honda') {
            window.location.hash = '';
        }
    });

    window.addEventListener('load', function () {
        checkUrlAndTrigger();
        openLoadBuildMoal();
        openProductListModal();
        updateRedirectLinksWithOrderParams();
        configuratorUpdateCarModelModalUrl();
    });
    window.addEventListener('hashchange', function () {
        checkUrlAndTrigger();
    });

    $('body').on('click', '#page-sidebar-collapse button[data-target="#page-sidebar-collapse"]', function () {
        $('#sidebarTestDrive').collapse('hide');
        $('#sidebarDownloadBrochure').collapse('hide');
        $('#sidebarLocation').collapse('hide');
        window.location.hash = '#!';
    });

    const sidebarLinkIds = ['sidebarBuild', 'sidebarFind', 'sidebarFinance', 'sidebarService'];
    sidebarLinkIds.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        }
    });

    $(document).on('click', '.selectCarModal.modal a.redirect-cta', function () {
        frontendUtils.deleteCookie('dapModalShown');
    });
});

$(document).ready(function () {
    if (window.location.hash === '#!/brochure') {
        sidebar.brochureurltriggers();
        window.location.hash = '#!/brochure';
    } else if (window.location.hash === '#!/testdrive') {
        sidebar.testdrivetriggers();
        window.location.hash = '#!/testdrive';
    }
    if (window.location.hash === '#!/location') {
        sidebar.locationtrigger();
        window.location.hash = '#!/location';
    }
})
module.exports = {
    sidebar: sidebar,
    methods: {
        init: sidebar.init
    },
};
